import React, { useState, useContext } from 'react'
import UserContext from '../../context/Globales/UserContext';
import {

    makeStyles,
    TableContainer, Table, TableCell, TableRow, TableHead, TableBody, Button, Grid, Modal, Fade, Backdrop
} from '@material-ui/core';
import { v4 as uuid } from 'uuid';

import IcpdfProtestoModal from '../pdf/IC/IcpdfProtestoModal';
import moment  from 'moment';

const formatterPeso = new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP'
})





const useStyles = makeStyles((theme) => ({
    tituloTable: {

        backgroundColor: '#e6e6e6',
        minWidth: 200,
        color: 'black',
        textAlign: 'center',
        padding: '16px',
        fontWeight: '250',
        fontSize: '16px'
    },
    TituloIdentificacion: {

        backgroundColor: theme.palette.primary.main,
        minWidth: 200,
        color: 'white',
        textAlign: 'center',
        padding: '15px',
        fontWeight: '250',
        fontSize: '18px',
        height: 'auto',
        alignContent: 'center',
    },
    FondoTable: {

        backgroundColor: theme.palette.greyFondo.main
    },
    containerTable: {
        maxHeight: 440,
        maxWidth: '100%'
    },


    modalPdf: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      },
      paperPdf: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: '50%',
      },
}));

const TblProtestos = () => {
    const classes = useStyles();
    const { datoICMODAL } = useContext(UserContext);
    const [OpenModalpdfProtesto, setOpenModalpdprotesto] = React.useState(false); 


    const [DatosDetalleImpagos] = useState(datoICMODAL.RegistrosMorosidadesYProtestos?.Protestos);
    const [DatosDetalleImpagosSinacofiModal] = useState(datoICMODAL.RegistrosMorosidadesYProtestos?.ProtestosSinacofi);

    const handlClickOpenPdf =()=>{

        setOpenModalpdprotesto(!OpenModalpdfProtesto); 


    }; 

    const handlClickClose =()=>
    {
        setOpenModalpdprotesto(false); 
    }


    return (
        <div>


         {/*MODAL PDF INFORME COMER*/}

  <Modal
    aria-labelledby="transition-modal-title"
    aria-describedby="transition-modal-description"
    className={classes.modalPdf}
    open={OpenModalpdfProtesto}
    onClose={handlClickClose}
    closeAfterTransition
    BackdropComponent={Backdrop}
    BackdropProps={{
      timeout: 2000,
    }}>
    <Fade in={OpenModalpdfProtesto}>
    
      <div className={classes.paperPdf}>


        <IcpdfProtestoModal  />      

 
      
      </div>
 
    </Fade> 
    </Modal>





    <h6 className={classes.tituloTable}>Detalle de Protesto</h6>
            <br />
            {datoICMODAL.DetallesMorosidadesYProtestos?.Protestos != null ? <div style={{ alignContent: "center", textAlign: "center" }}><Button variant="contained" color="primary" onClick={handlClickOpenPdf}>Descargar PDF</Button></div> : ''}

            <br />

            {datoICMODAL.DetallesMorosidadesYProtestos?.Protestos == null ? <h2>Cargando información...</h2> : ''}


            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="flex-start"
            >
                <Grid item xs={6} sm={6} xl={6} md={6} lg={6}>
                    <TableContainer >

                        <Table>

                            <TableHead className={classes.FondoTable}>

                                <TableRow >

                                    <TableCell>Cant. Documentos:  </TableCell>
                                    <TableCell>Fecha más reciente</TableCell>
                                    <TableCell>Monto total</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow >

                                    <TableCell>{datoICMODAL.DetallesMorosidadesYProtestos?.Protestos?.NumeroDocumentos}</TableCell>
                                    <TableCell>{datoICMODAL.DetallesMorosidadesYProtestos?.Protestos?.FechaMasReciente}</TableCell>
                                    <TableCell align="right"><strong>$ {datoICMODAL.DetallesMorosidadesYProtestos?.Protestos?.MontoTotal}</strong></TableCell>
                                </TableRow>

                            </TableBody>


                        </Table>
                    </TableContainer>
                </Grid>



            </Grid>


            <TableContainer className={classes.containerTable}>
                <Table>
                    <TableHead className={classes.FondoTable}>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Tipo Doc.</TableCell>
                            <TableCell>F. Venc.</TableCell>
                            <TableCell>Moneda</TableCell>
                            <TableCell>Monto.</TableCell>
                            <TableCell>Librador.</TableCell>
                            <TableCell>Tipo de deudad</TableCell>
                            <TableCell>Localidad.</TableCell>


                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {DatosDetalleImpagos.map((datadetallprotesto, idprotesto) => (


                            <TableRow key={idprotesto}>
                                <TableCell>{idprotesto + 1}</TableCell>
                                <TableCell>{datadetallprotesto.TipoDocumento}</TableCell>
                                <TableCell>{datadetallprotesto.FechaVencimientoProtesto}</TableCell>
                                <TableCell>{datadetallprotesto.Moneda}</TableCell>
                                <TableCell align="right"><strong>  {datadetallprotesto.Monto}</strong></TableCell>
                                <TableCell>{datadetallprotesto.Librador}</TableCell>
                                <TableCell>{datadetallprotesto.TipoDeuda}</TableCell>
                                <TableCell>{datadetallprotesto.Localidad}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

            </TableContainer>

            <h6 className={classes.tituloTable}>Detalle de Protesto Sinacofi</h6>


            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="flex-start"
            >
                <Grid item xs={6} sm={6} xl={6} md={6} lg={6}>
                    <TableContainer >

                        <Table>

                            <TableHead className={classes.FondoTable}>

                                <TableRow >

                                    <TableCell>Cant. Documentos:  </TableCell>
                                    <TableCell>Fecha más reciente</TableCell>
                                    <TableCell>Monto total</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow >

                                    <TableCell>{datoICMODAL.Resumenes?.ProtestosVigentesSinacofi?.TotalDocumentos}</TableCell>
                                    <TableCell>--</TableCell>
                                    <TableCell align="right">--</TableCell>
                                </TableRow>

                            </TableBody>


                        </Table>
                    </TableContainer>
                </Grid>



            </Grid>


            <TableContainer className={classes.containerTable}>
                <Table>
                    <TableHead className={classes.FondoTable}>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Tipo Doc.</TableCell>
                            <TableCell>F. Venc.</TableCell>
                            <TableCell>Moneda</TableCell>
                            <TableCell>Monto.</TableCell>
                            <TableCell>Librador.</TableCell>
                            <TableCell>Tipo de deudad</TableCell>
                            <TableCell>Localidad.</TableCell>


                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {DatosDetalleImpagosSinacofiModal.map((datadetallprotesto, idprotesto) => (


                            <TableRow key={idprotesto}>
                                <TableCell>{idprotesto + 1}</TableCell>
                                <TableCell>{datadetallprotesto.TipoDocumento}</TableCell>
                                <TableCell>{moment(datadetallprotesto.FechaVencimientoProtesto).format('DD/MM/YYYY')}</TableCell>
                                <TableCell>{datadetallprotesto.Moneda}</TableCell>
                                <TableCell align="right"><strong> {datadetallprotesto.Monto}</strong></TableCell>
                                <TableCell>{datadetallprotesto.Librador}</TableCell>
                                <TableCell>{datadetallprotesto.TipoDeuda}</TableCell>
                                <TableCell>{datadetallprotesto.Localidad}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

            </TableContainer>



        </div>
    )
}

export default TblProtestos
